/* tslint:disable */
/* eslint-disable */
export enum GlobalSearchResultTypeEnum {
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  STACK_COMPANY = 'STACK_COMPANY',
  CONTACT_PROFILE = 'CONTACT_PROFILE'
}
